import { Component } from '@angular/core';

@Component({
  selector: 'ocp-auth-layout',
  template: `<ng-content />`,
  styles: `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background-color: var(--surface-brand-muted-200);
      padding: var(--spacing-12);
    }
  `,
})
export class AuthLayoutComponent {}
